import type {AccessScope} from './types';
import {isHeadquartersScope} from '../headquarters-site-navigation';

/** A new HQ session must not inherit a factory-only route from the previous login. */
export function workspaceLoginPath(scope: AccessScope | undefined, path: string): string {
  if(!scope || scope.resource.kind !== 'tenant' || !isHeadquartersScope(scope)) return path;
  const pathname=path.split(/[?#]/u,1)[0]!.replace(/\/+$/u,'') || '/';
  const factoryRoute=/^\/(?:risk-assessment|incidents|inspections|field|tbm|education|safety-content|work|budget|assets|heat-index|equipment-dispatch|activity-plan|equipment-safety-inspection|communications)(?:\/|$)/u;
  return pathname==='/' || factoryRoute.test(pathname) ? '/headquarters' : path;
}
